import { VueMaskDirective } from "v-mask";

const mixin = {
  directives: {
    VueMaskDirective,
  },

  data() {
    return {
      return_type: "",
      mask_cpf: "###.###.###-##",
      mask_cnpj: "##.###.###/####-##",
      mask_phone: "(##) # #### ####",
      mask_cep: "#####-###",
      date: "##/##/####",
    };
  },
};

export default mixin;
